export const NAME = '安徽灵犀机器人有限公司';
export const ADDRESS = '安徽省合肥市肥西县桃花镇科大硅谷肥西园B5栋502室';
export const PHONE = '18788882680';
export const EMAIL = 'lx-robot@163.com';
export const BUSINESS_HOURS = '周一至周五 9:00-18:00';
export const WEBSITE = 'https://www.lxrobot.com';
export const COMPANY_NAME = 'LX机器人';
// export const COMPANY_LOGO = require('../static/img/logo.png');
export const LOCATION = 'https://map.baidu.com/search/%E5%AE%89%E5%BE%BD%E7%81%B5%E7%8A%80%E6%9C%BA%E5%99%A8%E4%BA%BA%E6%9C%89%E9%99%90%E5%85%AC%E5%8F%B8/@13041724.255,3714134.51,19z?querytype=s&da_src=shareurl&wd=%E5%AE%89%E5%BE%BD%E7%81%B5%E7%8A%80%E6%9C%BA%E5%99%A8%E4%BA%BA%E6%9C%89%E9%99%90%E5%85%AC%E5%8F%B8&c=1&src=0&wd2=%E5%90%88%E8%82%A5%E5%B8%82%E8%82%A5%E8%A5%BF%E5%8E%BF&pn=0&sug=1&l=13&b=(12689382,2602649;12735462,2627545)&from=webmap&biz_forward=%7B%22scaler%22:2,%22styles%22:%22pl%22%7D&sug_forward=31e299d84a7b05581029358a&device_ratio=2'
export const LATITUDE = 31.792218;
export const LONGITUDE = 117.148038;
export const AMAP_KEY = '8cbbebc31679a5a995bc5c89259a0707';

export default {
  NAME,
  ADDRESS,
  PHONE,
  EMAIL,
  BUSINESS_HOURS,
  WEBSITE,
  COMPANY_NAME,
  LOCATION,
  LATITUDE,
  LONGITUDE,
  AMAP_KEY
};
